<template>
  <section class="main-content">
    <MainBanner banner="Projekte" />
    <script type="application/ld+json">
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Startseite - ito consult GmbH",
        "item": "https://ito-consult.de"
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "Projekte",
        "item": "https://ito-consult.de/projekte"
      }]
    }
  </script>
    <section class="block-content py-5 mb-5 bg-grey">
        <div class="container my-md-5 py-md-5">
            <div class="content-midwide" data-aos="fade-up" data-aos-duration="1000" data-aos-offset="100">
              <article v-html="content.content"></article>
              <a v-if="!content.cta_interal" :href="content.cta_button_link" class="btn btn-outline-ito hover-red animated-arrow mt-3 d-inline-flex align-items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"></path></svg> {{content.cta_text}}
              </a>
              <router-link :title="content.cta_text" v-else-if="content.cta_text && content.cta_button_link" :to="content.cta_button_link" class="btn btn-outline-ito hover-red animated-arrow mt-3 d-inline-flex align-items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"></path></svg> {{content.cta_text}}
              </router-link>
            </div>
        </div>
    </section>
    <section class="block-content bg-grey mb-5">
        <div class="fluid-container my-md-5 py-md-5">
            <div class="row g-5 references">
                <div v-for="(p,index) in projects" :key="p.id" class="col-12 col-sm-6 col-md-3" data-aos="fade-up" data-aos-duration="1000" data-aos-offset="100" :data-aos-delay="index*50">
                  <div class="ref position-relative">
                    <img v-if="p.image" class="img-fluid" :src="getThumbURL(p.image.private_hash)" />
                    <img v-else class="img-fluid" :src="placeholder500" />
                    <router-link title="zum Projekt" :to="{name: 'projects.single', params: {id : p.slug}}" class="stretched-link"></router-link>
                  </div>
                </div>
            </div>
        </div>
    </section>
  </section>
</template>

<script>

import axios from 'axios'
import store from '@/store'
const MainBanner = () => import('@/components/Content/MainBanner.vue')

export default {
  name: 'Projects',
  metaInfo () {
    return {
      title: this.$parent.getMetaTitle('Projekte'),
      meta: [
        { name: 'description', content: this.$parent.getDescription('Projekte') },
        { property: 'og:title', content: this.$parent.getOGTitle('Projekte') },
        { property: 'og:description', content: this.$parent.getOGDescription('Projekte') }
      ],
      placeholder500: require('@/assets/gfx/placeholder_500x350.jpg')
    }
  },
  data: function () {
    return {
      projects: {}
    }
  },
  async beforeMount () {
    await axios.get('/projects?fields=*.*')
      .then(response => {
        this.projects = response.data.data
        store.commit('loadingStatus', false)
      })
  },
  components: {
    MainBanner
  },
  computed: {
    content () {
      if (typeof this.$store.getters.content.data !== 'undefined') {
        const txt = this.$store.getters.content.data.filter(item => {
          return item.title.indexOf('Projekte-Einleitung') > -1
        })
        return txt.length ? txt[0] : ''
      } else {
        return ''
      }
    }
  },
  methods: {
    getThumbURL: function (hash) {
      return 'https://cdn.ito-consult.de/itoconsult/assets/' + hash + '?w=500&h=350&f=crop&q=70'
    }
  }

}
</script>

<style scoped>
  .fluid-container {max-width: 1600px; margin: 0 auto;}

  .references .ref {overflow: hidden; display: block; border: 2px solid #fff}
  .references .ref img {filter: grayscale(1); transition: all 1s;}
  .references .ref:hover img {transform: scale(1.05,1.05); filter: grayscale(0);}
</style>
